import script from "./PUR08_003INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR08_003INS.vue?vue&type=script&setup=true&lang=js"

import "./PUR08_003INS.vue?vue&type=style&index=0&id=5fff8c6e&scoped=true&lang=css"
import "./PUR08_003INS.vue?vue&type=style&index=1&id=5fff8c6e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fff8c6e"]])

export default __exports__